import { TipoOpposizione } from 'src/app/common/models/tipologiche/tipo-opposizione';
import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloOpposizioneDecretoIngiuntivo extends FascicoloFull {
  tipoOpposizione: TipoOpposizione;
  sezione: string;
  motivoOpposizione: string;
  numRuoloDecretoRif: string;
  posizioneFascicoloRif: string;
  dataInizioFascicoloRif: number;
  valoreFascicoloRif: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
